import { Check, ArrowUpRight } from "lucide-react";
import { Overline, Reveal } from "./Primitives";
import { useT } from "@/lib/i18n";
import { scrollToId } from "@/lib/scroll";

export const Pricing = ({ onPick }) => {
  const t = useT().pricing;
  const pick = (id) => { onPick(id); scrollToId("contact"); };
  return (
    <section id="pricing" className="py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <Overline>{t.over}</Overline>
          <h2 className="mt-6 font-display font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">{t.title}</h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-2 gap-6 max-w-5xl">
          {t.plans.map((p, i) => (
            <Reveal key={p.id} delay={i * 0.12}>
              <div data-testid={`pricing-card-${p.id}`}
                className={`price-card relative h-full rounded-[28px] p-8 md:p-12 border flex flex-col ${p.featured ? "border-[var(--gold)]/60 bg-gradient-to-b from-[#2a2219] to-[#15120f]" : "border-[var(--line)] bg-[var(--card)]"}`}>
                {p.featured && <span className="absolute top-6 right-6 font-mono text-[11px] uppercase tracking-[0.2em] text-[#0c0a09] bg-[var(--gold)] rounded-full px-3 py-1">{t.popular}</span>}
                <h3 className="font-display text-3xl pr-28">{p.t}</h3>
                <div className="mt-8 flex items-baseline gap-3">
                  <span className="font-display text-7xl md:text-8xl font-light tracking-tight" data-testid={`pricing-price-${p.id}`}>{p.p}</span>
                  <span className="font-mono text-sm text-stone-300">{p.per}</span>
                </div>
                <ul className="mt-10 space-y-4 flex-1">
                  {p.f.map((f) => (
                    <li key={f} className="flex gap-3 text-stone-200"><Check size={18} className="text-[var(--gold)] mt-0.5 shrink-0" />{f}</li>
                  ))}
                </ul>
                <button data-testid={`pricing-choose-${p.id}`} onClick={() => pick(p.id)} className={`mt-10 w-full justify-center ${p.featured ? "btn-gold" : "btn-ghost"}`}>
                  {t.choose} <ArrowUpRight size={18} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
